// components/ui/Switch.tsx
// -----------------------------------------------------------------------------
// Toggle switch component with native web checkbox styling and mobile colors.
// -----------------------------------------------------------------------------

import { cn } from "./cn";

interface SwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * Switch component using native checkbox with custom styling.
 * Uses blue color when checked, matching mobile coreColors.blue.
 */
export function Switch({
  checked,
  onCheckedChange,
  disabled = false,
  className,
}: SwitchProps) {
  return (
    <label className={cn("relative inline-flex cursor-pointer", disabled && "cursor-not-allowed opacity-50", className)}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onCheckedChange(e.target.checked)}
        disabled={disabled}
        className="sr-only peer"
      />
      <div className="w-11 h-6 bg-text-disabled peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue/30 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all after:shadow-sm peer-checked:bg-blue" />
    </label>
  );
}
